<app-slide id="paymentMethodSlide" title="Payment Method"
    supportingText="We need some details on how you will be making your future rent payments"
    [slideNumber]="slideNumber" [finalSlide]="finalSlide" [active]="active.active === 'paymentMethod'"
    [slideCompleted]="formState.progress.paymentMethodComplete">

    <app-spinner *ngIf="loading"></app-spinner>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
        {{ errorMessage }}
    </div>

    <div id="payment-method-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it again.</p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title}}, {{error.msg}}</a>
            </li>
        </ul>
    </div>

    <!-- {{model | json}} -->

    <form id="paymentMethodForm" name="paymentMethodForm" #paymentMethodForm (submit)="onSubmit()">
        <div class="section" id="payment-method-form-controls">

            <div class="form-group schema-form-radiobuttons"
                *ngFor="let question of model.applicationPaymentMethodQuestions | filterObjects: {'name': 'cn_howwillyourrentbepaid'}">
                <label class="control-label">
                    How will your rent be paid?
                </label>
                <div class="btn-group toggle-buttons wide" id="{{question.name}}">
                    <label class="btn btn-secondary" *ngFor="let answer of question.answers"
                        [ngClass]="{active: answer.active === 'true'}">
                        <input name="{{question.name}}" (click)="setActive(question.name, answer)" type="radio"
                            style="display: none;" value="{{answer.name}}" /> {{answer.name}}
                    </label>
                </div>
                <div [hidden]="(errors | filterObjects: {'name': 'cn_howwillyourrentbepaid'}).length > 0"
                    *ngIf="(errors | filterObjects: {'name': 'cn_howwillyourrentbepaid'}).length > 0" class="has-error">
                    <div class='help-block'>Please select one of the answers</div>
                </div>
            </div>

            <ng-container
                *ngFor="let question of model.applicationPaymentMethodQuestions | filterObjects: {'name': 'cn_howwillyoubepaying', 'active': 'true'}">
                <div class="form-group schema-form-radiobuttons" *ngIf="question.active">
                    <label class="control-label" id="{{question.name + '-label'}}">
                        How will you pay?
                    </label>
                    <div class="btn-group toggle-buttons wide">
                        <label class="btn btn-secondary" *ngFor="let answer of question.answers"
                            [class.active]="answer.active === 'true'">
                            <input name="{{question.name}}" (click)="setActive(question.name, answer)" type="radio"
                                style="display: none;" value="{{answer.name}}" /> {{answer.name}}
                        </label>
                    </div>
                    <div *ngIf="(help | filterObjects: {'id': 'directdebit', 'active': 'true'}).length > 0">
                        <div class='help-block'>A member of the income team will contact you to set up your Direct Debit
                            once your tenancy has been created.</div>
                    </div>
                    <div *ngIf="(help | filterObjects: {'id': 'online', 'active': 'true'}).length > 0">
                        <div class='help-block'>It is your responsibility to ensure payments are made every week as per
                            your
                            tenancy agreement.</div>
                    </div>
                    <div *ngIf="(errors | filterObjects: {'id': 'cn_howwillyoubepaying'}).length > 0" class="has-error">
                        <div class='help-block'>Please select one of the answers</div>
                    </div>
                </div>
            </ng-container>

            <ng-container
                *ngFor="let question of model.applicationPaymentMethodQuestions | filterObjects: {'name': 'cn_doyoucurrentlyreceive', 'active': 'true'}">
                <div class="form-group schema-form-radiobuttons" *ngIf="question.active">
                    <label class="control-label" id="{{question.name + '-label'}}">
                        Do you currently recieve any of the following?
                    </label>
                    <div class="btn-group toggle-buttons wide">
                        <label class="btn btn-secondary" *ngFor="let answer of question.answers"
                            [class.active]="answer.active === 'true'">
                            <input name="{{question.name}}" (click)="setActive(question.name, answer)" type="radio"
                                style="display: none;" value="{{answer.name}}" /> {{answer.name}}
                        </label>
                    </div>
                    <div class='help-block'>It is your responsibility to ensure a new claim or change of circumstances
                        is
                        made.</div>
                    <div *ngIf="(errors | filterObjects: {'id': 'cn_doyoucurrentlyreceive'}).length > 0"
                        class="has-error">
                        <div class='help-block'>Please select one of the answers</div>
                    </div>
                </div>
            </ng-container>

            <ng-container
                *ngFor="let question of model.applicationPaymentMethodQuestions | filterObjects: {'name': 'cn_currentlymakecontributiontoyourrent', 'active': 'true'}">
                <div class="form-group schema-form-radiobuttons" *ngIf="question.active">
                    <label class="control-label" id="{{question.name + '-label'}}">
                        Do you make a contribution to your rent?
                    </label>
                    <div class="btn-group toggle-buttons wide">
                        <label class="btn btn-secondary" *ngFor="let answer of question.answers"
                            [class.active]="answer.active === 'true'">
                            <input name="{{question.name}}" (click)="setActive(question.name, answer)" type="radio"
                                style="display: none;" value="{{answer.name}}" /> {{answer.name}}
                        </label>
                    </div>
                    <div *ngIf="(errors | filterObjects: {'id': 'cn_currentlymakecontributiontoyourrent'}).length > 0"
                        class="has-error">
                        <div class='help-block'>Please select one of the answers</div>
                    </div>
                </div>
            </ng-container>


            <ng-container
                *ngFor="let question of model.applicationPaymentMethodQuestions | filterObjects: {'name': 'cn_howdoyouintendonpayinganyshortfall', 'active': 'true'}">
                <div class="form-group schema-form-radiobuttons" *ngIf="question.active">
                    <label class="control-label" id="{{question.name + '-label'}}">
                        How do you intend to make your contribution?
                    </label>
                    <div class="btn-group toggle-buttons wide">
                        <label class="btn btn-secondary" *ngFor="let answer of question.answers"
                            [class.active]="answer.active === 'true'">
                            <input name="{{question.name}}" (click)="setActive(question.name, answer)" type="radio"
                                style="display: none;" value="{{answer.name}}" /> {{answer.name}}
                        </label>
                    </div>
                    <div *ngIf="(help | filterObjects: {'id': 'shortfallDirectdebit', 'active': 'true'}).length > 0">
                        <div class='help-block'>A member of the income team will contact you to set up your Direct Debit
                            once your tenancy has been created.</div>
                    </div>
                    <div *ngIf="(help | filterObjects: {'id': 'shortfallOnline', 'active': 'true'}).length > 0">
                        <div class='help-block'>It is your responsibility to ensure payments are made every week as per
                            your
                            tenancy agreement.</div>
                    </div>
                    <div *ngIf="(errors | filterObjects: {'id': 'cn_howdoyouintendonpayinganyshortfall'}).length > 0"
                        class="has-error">
                        <div class='help-block'>Please select one of the answers</div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="section ng-empty" id="payment-method-back-forward">
            <div class="row">
                <div class="col-sm-8">
                    <div class="form-group ">
                        <button type="button" class="btn" style="position:relative;" (click)="onBack()">
                            <span>Back</span>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group ">
                        <button type="submit" class="btn btn-primary" style="position: relative;"
                            [disabled]="isDisabled">
                            <span>Save &amp; Continue Securely</span>
                            <!-- app-spinner -->
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>

</app-slide>